import { useEffect, useState } from 'react';
import { useAuth } from '@chainlit/react-client';
import Page from 'pages/Page';

export default function AIOpsDashboard() {
  const { isAuthenticated } = useAuth();
  const [loaded, setLoaded] = useState(false);
  const [ready, setReady] = useState(false); // adds slight delay after iframe load
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Optional auth bootstrap
  }, [isAuthenticated]);

  const handleLoad = () => {
    setLoaded(true);
    // Give embedded dashboard a moment to render internal assets
    const t = setTimeout(() => setReady(true), 800);
    return () => clearTimeout(t);
  };

  return (
    <Page>
      <div className="relative w-full h-[calc(100vh-56px)]">
        {!ready && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-background/80 backdrop-blur-sm z-10">
            <div className="h-10 w-10 animate-spin rounded-full border-2 border-[#18E78F]/30 border-t-[#18E78F]" />
            <p className="text-xs text-muted-foreground">
              {error
                ? error
                : loaded
                ? 'Finalizing dashboard…'
                : 'Loading dashboard…'}
            </p>
          </div>
        )}
        <iframe
          src="https://p.datadoghq.com/sb/embed/6a74d14e-c9f9-11eb-a6c2-da7ad0900002-ba5e41b255a004f1c34550404e10714b"
          title="AIOps Dashboard"
          className="w-full h-full border-0"
          allow="fullscreen"
          onLoad={handleLoad}
          onError={() => setError('Failed to load iframe')}
        />
      </div>
    </Page>
  );
}